import type { User } from '@psp-aggregator/sdk';

export const getUserDisplayName = (user: User): string => {
  const first = (user.first_name ?? '').trim();
  const last = (user.last_name ?? '').trim();
  const fullName = `${first} ${last}`.trim();

  if (fullName) {
    return fullName;
  }

  return user.email;
};
